import React, { useState } from 'react';
import { Grid, Message } from 'semantic-ui-react';
import { AccordionWrapper } from 'react-lib/dist/components-es';
import IChemicalRiskInhalationContainer from './ChemicalRiskInhalationInformation/IChemicalRiskInhalationContainer';
import { InputWrapper } from 'react-lib/dist/components-es';
import ChemicalRisk from '../GeneralInformation/ChemicalInformation/ChemicalRisk';
import IPreventionProtectionMeasuresContainer from './PreventionProtectionInformation/IPreventionProtectionMeasuresContainer';
import IOtherPrecautions from './PreventionProtectionInformation/IOtherPrecautions';
import IChemicalRiskCheckedCseInformationContainer from './CheckedInformation/IChemicalRiskCheckedCseInformationContainer';
import { risksActions } from '../../../../behavior/risks';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';

type Props = {
  values: any;
  chemRiskCalculation: () => void;
  disabled: boolean;
  setFieldValue: (arg1: string, arg2: string | null) => void;
  initialData: any;
  setValidateOnChange: (arg: boolean) => void;
  validateOnChange: boolean;
  mode: string;
  errors: any;
  setOverridePersonState: (arg: boolean) => void;
};

const IChemicalRiskInformationContainer = ({
  values,
  chemRiskCalculation,
  disabled,
  initialData,
  setFieldValue,
  setValidateOnChange,
  mode,
  errors,
  validateOnChange,
  setOverridePersonState,
}: Props) => {
  const { t } = useTranslation();
  const [isChemRiskCalculationVisible, setIsChemRiskCalculationVisible] = useState<boolean>(
    values.chemicalRiskAttributes.hasChemRiskCalculation || false
  );
  const conditionToDisplayChemRisk =
    values.chemicalProduct &&
    values.chemicalProduct.state &&
    [2, 3].includes(values.chemicalProduct.state.id);

  values.chemicalRiskAttributes.hasChemRiskCalculation = isChemRiskCalculationVisible;

  if (!conditionToDisplayChemRisk && isChemRiskCalculationVisible) {
    values.chemicalRiskAttributes = {
      hasChemRiskCalculation: false,
      exposedPersons: [],
      edmsNumbersExposureMonitoring: [],
    };
  }

  const getTitleAdditions = () => {
    return (
      <>
        {getHasChemRiskCalculation()}
        <ChemicalRisk
          initialChemRiskLevelResultDto={values.chemicalRiskAttributes.chemRiskLevel}
          values={values}
        />
      </>
    );
  };

  const getHasChemRiskCalculation = () => {
    return (
      <span className="enableRiskCalculation" onClick={e => e.stopPropagation()}>
        <InputWrapper
          type="checkbox"
          toggle
          value={isChemRiskCalculationVisible}
          name="chemicalRiskAttributes.hasChemRiskCalculation"
          onChange={hasChemRiskCalculationToggle}
          disabled={disabled}
        />
      </span>
    );
  };

  const hasChemRiskCalculationToggle = () => {
    clearChemRiskAttributes();
    setIsChemRiskCalculationVisible(prev => !prev);
    chemRiskCalculation();
  };

  const clearChemRiskAttributes = () => {
    values.chemicalRiskAttributes = {
      id: values.chemicalRiskAttributes.id,
      exposedPersons: [],
      edmsNumbersExposureMonitoring: [],
      hasChemRiskCalculation: false,
      chemicalProductStateId: values.chemicalProduct.id,
    };
  };

  const getWarning = () => {
    return (
      values.chemicalProduct &&
      (!values.chemicalProduct.band || !values.chemicalProduct.band.id) && (
        <div>
          <Message color="yellow">
            {t('inventory.details.page.chemical.risk.inf.container.empty.band.warning')}
          </Message>
        </div>
      )
    );
  };

  const getChemicalRiskInformationContainerContent = () => {
    return isChemRiskCalculationVisible ? (
      <Grid stackable columns={1}>
        <Grid.Column className="detailsGridCol">
          {getWarning()}
          <IChemicalRiskInhalationContainer
            values={values}
            disabled={disabled}
            mode={mode}
            errors={errors}
            initialData={initialData}
            setFieldValue={setFieldValue}
            validateOnChange={validateOnChange}
            setOverridePersonState={setOverridePersonState}
          />
          <IPreventionProtectionMeasuresContainer
            values={values}
            disabled={disabled}
            initialData={initialData}
            setFieldValue={setFieldValue}
            errors={errors}
          />
          <IOtherPrecautions
            values={values}
            disabled={disabled}
            errors={errors}
            setFieldValue={setFieldValue}
          />
          <IChemicalRiskCheckedCseInformationContainer
            values={values}
            disabled={disabled}
            setFieldValue={setFieldValue}
            setValidateOnChange={setValidateOnChange}
            initialData={initialData}
          />
        </Grid.Column>
      </Grid>
    ) : (
      <>{t('inventory.details.page.chemical.risk.inf.container.enable.risk.assessment')}</>
    );
  };

  return conditionToDisplayChemRisk ? (
    <AccordionWrapper
      collapsed={!isChemRiskCalculationVisible}
      accordionTitle="inventory.details.page.chemical.risk.inf.container.title"
      className="containerReducedWhiteSpace"
      titleAddition={getTitleAdditions()}
      render={getChemicalRiskInformationContainerContent}
    />
  ) : null;
};

const mapStateToProps = (state: any) => ({
  stateChange: state.chemicalProducts.stateChange,
});

const mapDispatchToProps = (dispatch: any) => ({
  chemRiskCalculation: () => dispatch(risksActions.chemRiskCalculation()),
});

export default connect(mapStateToProps, mapDispatchToProps)(IChemicalRiskInformationContainer);
